// 版本标记: 2025-02-23-V3-速率限制修复
import axios from 'axios'
import { getFromCache, saveToCache, recordSearch } from '../utils/cache';
import { recordApiCall } from '../utils/rateLimiter';

// API配置
const API_BASE_URL = "/api"

/**
 * 速率限制错误
 */
export class RateLimitError extends Error {
  constructor(message: string, public readonly remainingCalls?: number, public readonly cooldownRemaining?: number) {
    super(message);
    this.name = 'RateLimitError';
  }
}

/**
 * 调用LLM搜索API（v2 - 本地缓存直接返回，不检查速率限制）
 */
export const callLLM = async (userInput: string) => {

  if (!userInput || userInput.trim() === "") {
    console.log("⚠️ 用户输入为空")
    return null
  }

  // 1. 先查本地缓存（快速返回，不请求服务器）
  const cached = getFromCache(userInput)
  if (cached) {
    return {
      ...cached,
      fromCache: true,
      debugInfo: {
        kvEnabled: true,
        cacheHit: true,
        source: 'local'
      }
    }
  }

  // 2. 调用服务器API（不检查前端速率限制，让服务器端处理）
  try {
    const response = await axios.post(`${API_BASE_URL}/search`, {
      query: userInput
    }, {
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 30000
    })


    // 3. 只有真正的LLM查询才记录次数
    const isFromCache = response.data?.fromCache === true;
    if (!isFromCache) {
      recordApiCall(false) // 只有未缓存时才计数
      console.log("📊 新查询，消耗速率限制次数")
    } else {
      console.log("💾 服务器缓存命中，不消耗次数")
    }

    // 4. 保存到本地缓存（保存完整的搜索结果，而不是单个工具）
    if (response.data) {
      saveToCache(userInput, response.data)
    }

    // 5. 记录搜索历史
    recordSearch(userInput)

    return response.data

  } catch (err: any) {
    console.log("❌ 搜索API调用失败:", err.message)
    if (err.response) {
      console.log("   状态码:", err.response.status)
      console.log("   错误:", JSON.stringify(err.response.data))

      // 如果是API调用失败的错误，抛出详细错误信息
      if (err.response.data?.error) {
        const errorData = err.response.data
        if (errorData.details) {
          throw new Error(
            `API调用失败\n\n` +
            `详细信息:\n` +
            `• 中文版本: ${errorData.details.zhSuccess ? '✅ 成功' : '❌ 失败'}\n` +
            `• 英文版本: ${errorData.details.enSuccess ? '✅ 成功' : '❌ 失败'}\n` +
            `• DeepSeek密钥: ${errorData.details.hasDeepSeekKey ? '✅ 已配置' : '❌ 未配置'}\n` +
            `• 火山方舟密钥: ${errorData.details.hasVolcArkKey ? '✅ 已配置' : '❌ 未配置'}\n\n` +
            `请检查 Cloudflare Pages 的环境变量配置`
          )
        }
        throw new Error(errorData.error)
      }
    }
    return null
  }
}

/**
 * 调用LLM推荐API
 */
export const callRecommendLLM = async () => {
  console.log("🎯 获取首页推荐...")

  try {
    const response = await axios.get(`${API_BASE_URL}/search?type=recommend`, {
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 30000
    })

    console.log("✅ 推荐成功")
    return response.data

  } catch (err: any) {
    console.log("❌ 推荐API调用失败:", err.message)
    if (err.response) {
      console.log("   状态码:", err.response.status)
      console.log("   错误:", JSON.stringify(err.response.data))
    }
    return null
  }
}
